<template>
  <div>
    <v-container fluid>
      <v-snackbar
        :timeout="2000"
        v-model="openSnackbar"
        variant="tonal"
        class="ma-2"
        color="error"
        elevation="8"
      >
        <strong class="text-subtitle-1 pb-2">{{ errorMessage }}</strong>
      </v-snackbar>
      <v-card class="v-card--material pt-2 ma-1 rounded-lg" elevation="2">
        <v-row class="my-1">
          <v-col cols="12" lg="9" md="9" sm="9" xs="12">
            <div class="ml-2">
              <div
                class="font-weight-regular headline text-decoration-underline text-capitalize"
              >
                <span>Edit Curriculum CMS</span>
              </div>
            </div>
          </v-col>
        </v-row>
        <card-component>
          <v-row>
            <v-col cols="12" md="2" sm="2">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Academic Year
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      curriculumCMSDetails
                        ? curriculumCMSDetails.academicYear
                        : '--'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Business</div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      curriculumCMSDetails
                        ? curriculumCMSDetails.business
                        : '--'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Program</div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      curriculumCMSDetails ? curriculumCMSDetails.program : '--'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Week</div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      curriculumCMSDetails ? curriculumCMSDetails.week : '--'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Session</div>
                  <div
                    class="text-button mb-1"
                    v-text="parseInt(position) + 1"
                  ></div>
                </div>
              </div>
            </v-col>
          </v-row>
          <hr />
          <v-row>
            <v-col class="mt-2" cols="12" sm="4">
              <label class="font-weight-medium body-2">
                Session:
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                required
                v-model.trim="theme"
                placeholder="Enter Session"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="2">
              <label class="font-weight-medium body-2">
                Time:
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                required
                v-model.trim="themeTime"
                placeholder="Enter Time"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="2">
              <v-btn
                bottom
                right
                elevation="1"
                color="primary"
                @click="openConfirmDialog()"
              >
                <v-icon left> mdi-content-save </v-icon>
                Save
              </v-btn>
            </v-col>
            <v-col class="mt-2" cols="12" sm="2" v-if="uploadResourceFlag">
              <v-btn
                class="mb-2"
                title="Upload Resource"
                @click="openBulkUpload(false)"
                elevation="1"
                top
                color="accent"
              >
                <v-icon left>mdi-plus</v-icon>Upload Resources
              </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table
              disable-pagination
              :hide-default-footer="true"
              :headers="dayTableHeaders"
              :items="weekScheduleList"
            >
              <template v-slot:item.title="{ item }">
                <v-text-field
                  :class="{
                    'mr-0 my-1': $vuetify.breakpoint.xs,
                    'mr-5': $vuetify.breakpoint.smAndUp
                  }"
                  v-model="item.dayGlance.title"
                  hide-details="true"
                  label="Title"
                  dense
                  single-line
                  :style="
                    $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  "
                />
              </template>
              <template v-slot:item.lessonGuide="{ item }">
                <div
                  v-for="(lesson, index) in item.dayGlance.lessonGuideResource"
                  :key="index"
                  class="d-flex"
                >
                  <div class="mr-auto">{{ lesson.fileName }}</div>
                  <div>
                    <v-btn
                      :to="{
                        name: 'previewMedia',
                        params: { previewId: lesson.id }
                      }"
                      icon
                      color="primary"
                      small
                      title="View"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="primary"
                      small
                      v-if="lesson.isDownloadable"
                      @click="downloadResource(lesson.id)"
                      title="Download"
                    >
                      <v-icon small>mdi-arrow-down-bold</v-icon>
                    </v-btn>
                    <v-btn
                      @click="deleteResource(lesson.id)"
                      color="error"
                      icon
                      small
                      title="Delete"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:item.resourceContent="{ item }">
                <span v-if="item.dayGlance.resourceContent.length">
                  <div
                    v-for="(lesson, index) in item.dayGlance.resourceContent"
                    :key="index"
                    class="d-flex grow"
                  >
                    <div :title="lesson.fileName">{{ lesson.fileName }}</div>
                    <div class="ml-auto">
                      <v-btn
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        title="View"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="lesson.isDownloadable"
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  @click="updateDayGlanceDetails(item.dayGlance)"
                >
                  <v-icon left> mdi-content-save </v-icon>
                  Save
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </card-component>
      </v-card>
    </v-container>
    <v-dialog v-model="confirmResource" max-width="500px">
      <v-card>
        <v-toolbar class="warning">
          <v-toolbar-title>Warning</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="confirmResource = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items> </v-toolbar
        ><br />
        <p class="pl-3">
          Do you want to retain the old Learning materials for this session?
        </p>
        <center>
          <p style="font-size: 18px">
            <b>
              {{ theme }}
            </b>
          </p>
        </center>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="retainAllMaterial()"
            >Retain the Old Materials</v-btn
          >
          <v-btn color="blue darken-1" @click="confirmUploadNewMaterial()" text
            >Upload New Materials</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmUploadNewMaterialDialog" max-width="500px">
      <v-card>
        <v-toolbar class="warning">
          <v-toolbar-title>Warning</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="confirmUploadNewMaterialDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items> </v-toolbar
        ><br />
        <p class="pl-3">
          All the previous files uploaded will be deleted after this action.
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="openBulkUpload(true)" text
            >Proceed</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkUploadDialog" width="90%">
      <v-card>
        <v-row class="mx-0">
          <v-toolbar class="pl-4" dark color="darkblue">
            <v-toolbar-title> Upload Resources </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-text style="border: solid 1px #e4e4e4">
              <v-row>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <v-file-input
                    :label="'Lesson Guide'"
                    v-model="selectedLessonFiles"
                    multiple
                    chips
                    :accept="allowedFiles"
                    truncate-length="15"
                    @change="updateDataLessonTable()"
                  ></v-file-input>
                  <v-divider></v-divider>
                  <v-data-table
                    :headers="lessonHeaders"
                    :items="lessonFileList"
                    hide-default-footer
                  >
                    <template v-slot:item.index="{ item }">
                      {{ item.index }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon @click="removeLessonFile(item.index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <p class="has-text-danger">
                    File Name Should be in below format <br />
                    For Day 1 session 1: D1_S1
                  </p>
                  <p class="has-text-danger">
                    Allowed file's: .pdf, .mov, .mpg, .avi, .mp4,
                    .wmv,.m4v,.jpg, .png, .jpeg
                  </p>
                  <p class="has-text-danger">
                    File's that are not supported will be removed automatically!
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-text style="border: solid 1px #e4e4e4">
              <v-row>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <v-file-input
                    v-model="selectedResourceFiles"
                    label="Resource Contents"
                    multiple
                    @change="updateDataTable"
                    :accept="allowedFiles"
                  ></v-file-input>
                  <v-divider></v-divider>
                  <v-data-table
                    :headers="headers"
                    :items="fileList"
                    hide-default-footer
                  >
                    <template v-slot:item.index="{ item }">
                      {{ item.index }}
                    </template>
                    <template v-slot:item.downloadable="{ item }">
                      <v-checkbox v-model="item.downloadable"></v-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon @click="removeFile(item.index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <p class="has-text-danger">
                    File Name Should be in below format <br />
                    For Day 1 session 1 Resource 1: D1_S1_1 <br />
                    For Day 1 session 1 Resource 2: D1_S1_2
                  </p>
                  <p class="has-text-danger">
                    Allowed file's: .pdf, .mov, .mpg, .avi, .mp4,
                    .wmv,.m4v,.jpg,.png, .jpeg
                  </p>
                  <p class="has-text-danger">
                    File's that are not supported will be removed automatically!
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-actions class="justify-end">
              <v-btn @click="closeBulkUploadDialog()"> Close </v-btn>
              <v-btn color="primary" @click="uploadBulkResource()"
                >Upload Resource</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bulkResponseDialog" width="800px">
      <div>
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Upload Resources </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="bulkUploadResponseHeaders"
              :items="errorFileList"
              hide-default-footer
            >
            </v-data-table>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="bulkResponseDialog = false"> Close</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
export default {
  name: 'editDayGlanceDetails',
  components: {
    CardComponent
  },
  props: ['folderMapID', 'position'],
  data () {
    return {
      errorMessage: null,
      openSnackbar: false,
      weekAtGlanceDetails: [],
      themeName: null,
      totalClassTime: 0,
      weekScheduleList: [],
      theme: '',
      themeTime: '',
      lessonFlag: false,
      lessonDialog: false,
      resourceDialog: false,
      uploadResources: false,
      allowedFiles: [
        '.pdf, .mov, .mpg, .avi, .mp4, .wmv,.m4v,.jpg, .png, .jpeg',
        'ppt',
        'pptx'
      ],
      isUploadLesson: false,
      isUploadResources: false,
      lessonType: 'LESSON',
      resourceType: 'RESOURCE',
      dropFile: null,
      themeID: null,
      previousFiles: [],
      isDownloadable: false,
      selectedResourceFiles: [],
      selectedLessonFiles: [],
      fileList: [],
      lessonFileList: [],
      headers: [
        { text: 'Index', value: 'index' },
        { text: 'Name', value: 'name' },
        { text: 'Downloadable', value: 'downloadable', align: 'center' },
        { text: 'Actions', value: 'actions' }
      ],
      lessonHeaders: [
        { text: 'Index', value: 'index' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions' }
      ],
      curriculumCMSDetails: null,
      confirmResource: false,
      dayTableHeaders: [
        { text: 'Day', value: 'dayName' },
        { text: 'Title', value: 'title' },
        { text: 'Lesson Guide', value: 'lessonGuide' },
        { text: 'Resource Content', value: 'resourceContent' },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      uploadResourceFlag: true,
      bulkUploadDialog: false,
      bulkResponseDialog: false,
      bulkUploadResponse: null,
      errorFileList: [],
      bulkUploadResponseHeaders: [
        { text: 'File Name', value: 'fileName' },
        { text: 'Content Type', value: 'contentType' },
        { text: 'Error Message', value: 'message' }
      ],
      confirmUploadNewMaterialDialog: false
    }
  },
  async created () {
    this.create = this.checkModuleAccess('create')
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getWeekScheduleList()
  },
  methods: {
    updateDataTable () {
      this.fileList = this.selectedResourceFiles.map((file, index) => ({
        index: index + 1,
        name: file.name,
        downloadable: false
      }))
    },
    updateDataLessonTable () {
      this.lessonFileList = this.selectedLessonFiles.map((file, index) => ({
        index: index + 1,
        name: file.name
      }))
    },
    removeFile (index) {
      const fileIndex = this.fileList.findIndex((file) => file.index === index)
      if (fileIndex !== -1) {
        this.fileList.splice(fileIndex, 1)
        this.fileList.forEach((file, index) => {
          file.index = index + 1
        })
        this.selectedResourceFiles.splice(fileIndex, 1)
      }
    },
    removeLessonFile (index) {
      const fileIndex = this.lessonFileList.findIndex(
        (file) => file.index === index
      )
      if (fileIndex !== -1) {
        this.lessonFileList.splice(fileIndex, 1)
        this.lessonFileList.forEach((file, index) => {
          file.index = index + 1
        })
        this.selectedLessonFiles.splice(fileIndex, 1)
      }
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getWeekScheduleList: async function () {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-position-day/${this.folderMapID}/${this.position}`
        )
        if (res.data.success !== 200 || !res.data.weekAtGlance.length) {
          const errorMessage = 'Something went wrong!'
          this.errMsg(errorMessage)
        }
        this.weekAtGlanceDetails = res.data.weekAtGlance
        this.curriculumCMSDetails = res.data.curriculumCMSDetails
        let days = res.data.weekAtGlance
        this.themeName = days[0].themeName || null
        this.totalClassTime = days[0].classTime || null
        if (this.totalClassTime) {
          const minutes = Number(this.totalClassTime % 60)
          const hours = Number(this.totalClassTime / 60).toFixed(0)
          this.totalClassTime = `${hours} hours`
          if (minutes > 0) {
            this.totalClassTime = `${hours} hours ${minutes} min `
          }
        }
        days = days.sort(function (a, b) {
          return a.dayName.localeCompare(b.dayName)
        })
        let row = {}
        row.days = days
        let finalArray = []
        for (let i in res.data.weekAtGlance) {
          let obj = {}
          obj.dayName = res.data.weekAtGlance[i].dayName
          obj.id = res.data.weekAtGlance[i].id
          obj.themeName = res.data.weekAtGlance[i].themeName
          obj.dayGlance = res.data.weekAtGlance[i].weekDay[0]
          obj.dayGlance.lessonGuideResource = []
          obj.dayGlance.resourceContent = []
          if (
            res.data.weekAtGlance[i].weekDay[0].lessonGuide &&
            res.data.weekAtGlance[i].weekDay[0].lessonGuide.length > 0
          ) {
            for (const resource of res.data.weekAtGlance[i].weekDay[0]
              .lessonGuide) {
              if (resource.section === 'RESOURCE CONTENT') {
                obj.dayGlance.resourceContent.push(resource)
              }
              if (resource.section === 'LESSON GUIDE') {
                obj.dayGlance.lessonGuideResource.push(resource)
              }
            }
          } else {
            obj.dayGlance.lessonGuideResource = []
            obj.dayGlance.resourceContent = []
          }
          finalArray.push(obj)
        }
        this.weekScheduleList = finalArray
        let daysArray = []
        for (let day of res.data.weekAtGlance) {
          day.weekDay = _.orderBy(day.weekDay, 'position', 'asc')
          daysArray.push(day.dayName)
          row[day.dayName] = day.weekDay
        }
        let TimeArray = row[daysArray[0]].map((obj) => obj.themeTime)
        this.themeTime = TimeArray[0]
        let sessionArray = row[daysArray[0]].map((obj) => obj.theme)
        this.theme = sessionArray[0]
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    deleteResource: async function (resID) {
      try {
        let res = await http.put(
          `${constants.API_URL}/api/curriculum_cms/in-active-file/${resID}`
        )
        if (res.status === 200) {
          this.$dialog.message.info('File deleted successfully.', {
            position: 'top-center',
            color: 'success',
            timeout: 4000
          })
        } else {
          this.$dialog.message.error('Failed to delete file.', {
            position: 'top-center',
            color: 'error',
            timeout: 4000
          })
        }
        await this.getWeekScheduleList()
      } catch (e) {
        this.$dialog.message.error(e.response.data.message, {
          position: 'top-center',
          color: 'error',
          timeout: 4000
        })
      }
    },
    downloadResource: async function (resID) {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-signed-url/${resID}`
        )
        if (res.status === 200) {
          window.open(res.data.filePath)
        } else {
          return this.$dialog.error({
            text: 'Failed to open file.',
            title: 'Error'
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: e.response.data.message,
          title: 'Error'
        })
      }
    },
    updateDayGlanceDetails: async function (dayGlance) {
      this.isLoading = true
      try {
        this.isLoading = true
        let formData = {
          dayGlanceID: dayGlance.id,
          position: dayGlance.position,
          title: dayGlance.title
        }
        const response = await http.post(
          `${constants.API_URL}/api/curriculum_cms/update-day-glance-details`,
          formData
        )
        if (response.status === 200) {
          this.okMsg(response.data)
        } else {
          const errorMessage = 'Unable to update details!'
          this.errMsg(errorMessage)
        }
        await this.getWeekScheduleList()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
    },
    openConfirmDialog () {
      this.confirmResource = true
    },
    updateDayGlanceSessionTime: async function () {
      this.isLoading = true
      try {
        let formData = {
          folderMapID: this.folderMapID,
          position: this.position,
          themeTime: this.themeTime,
          session: this.theme
        }
        const response = await http.post(
          `${constants.API_URL}/api/curriculum_cms/update-session-day-glance`,
          formData
        )
        if (response.status === 200) {
          this.okMsg(response.data)
        } else {
          const errorMessage = 'Unable to update details!'
          this.errMsg(errorMessage)
        }
        await this.getWeekScheduleList()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
    },
    retainAllMaterial: async function () {
      await this.updateDayGlanceSessionTime()
      this.confirmResource = false
    },
    deleteAllResources: async function () {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/delete-week-resources/${this.folderMapID}/${this.position}`
        )
        if (res.status === 200) {
          this.okMsg(
            'All Session resources deleted, Please upload new resources.'
          )
          this.uploadResourceFlag = true
        }
        await this.getWeekScheduleList()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
    },
    openBulkUpload: async function (deleteAll) {
      this.bulkUploadDialog = true
      if (deleteAll) {
        await this.deleteAllResources()
      }
    },
    closeBulkUploadDialog () {
      this.bulkUploadDialog = false
      this.lessonFileList = []
      this.selectedLessonFiles = []
      this.selectedResourceFiles = []
      this.fileList = []
      this.confirmResource = false
      this.confirmUploadNewMaterialDialog = false
    },
    uploadBulkResource: async function () {
      try {
        const formData = new FormData()
        const resourceFileData = this.fileList.map((file) => ({
          fileName: file.name,
          isDownloadable: file.downloadable
        }))
        const lessonFileData = this.lessonFileList.map((file) => ({
          fileName: file.name,
          isDownloadable: false
        }))
        for (let i in this.selectedResourceFiles) {
          formData.append('resourceFiles', this.selectedResourceFiles[i])
        }
        for (let i in this.selectedLessonFiles) {
          formData.append('lessonFiles', this.selectedLessonFiles[i])
        }
        formData.append('lessonFileData', JSON.stringify(lessonFileData))
        formData.append('resourceFileData', JSON.stringify(resourceFileData))
        formData.append('position', this.position)
        const response = await http.post(
          `${constants.API_URL}/api/curriculum_cms/upload-bulk-resources/${this.folderMapID}`,
          formData
        )
        this.bulkUploadDialog = false
        if (response.status === 200) {
          this.bulkUploadResponse = response.data.response
          this.errorFileList = response.data.errorFiles
          this.bulkResponseDialog = true
          this.bulkUploadDialog = false
          this.lessonFileList = []
          this.selectedLessonFiles = []
          this.selectedResourceFiles = []
          this.fileList = []
          this.confirmUploadNewMaterialDialog = false
          await this.getWeekScheduleList()
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
    },
    confirmUploadNewMaterial () {
      this.confirmResource = false
      this.confirmUploadNewMaterialDialog = true
    }
  }
}
</script>
